import { ErrorHandler } from "commonAssets/utils/ErrorHandler"

export class CustomErrorHandler extends ErrorHandler {
    /**
    * Returns the error status message based on the provided error object.
    * @param {Object} error - The error object.
    * @returns {string} - The error status message.
    */
    get_error_status(error) {
        // set a custom error status message for google cabrera
        if (error.data.code === 'GOOGLE_CUSTOMER_ID_ERROR') {
            return 'Google Customer ID Error';
        }
        return super.get_error_status(error);
    }
}